import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { CustomInput, FormGroup } from 'reactstrap';
import Datagrid from '../../../UI/Datagrid';
import { dashboardCustomizeAlarmListData } from './constants';
import ActionsDropdown from '../../Dashboard/helpers/ActionsDropdown';
import { getSharedDefaultStyles, getSpacingAround } from './functions';

const DashboardCustomWidget1 = ({ values, ...props }) => {
  const { t } = useTranslation('app');
  const columns = [
    {
      dataField: 'timeDetected',
      text: 'Time Detected',
      sort: true,
      isDateTime: true,
      headerStyle: { width: 150 },
      //   filter: selectFilter({
      //     options: selectOptions,
      //     defaultValue: '0',
      //     id: 'time-detected-filter',
      //     onFilter: filterTimeDetected,
      //   }),
    },
    {
      dataField: 'department',
      text: 'Department',
      sort: true,
      //   hidden: groupId ? true : false,
      //   headerStyle: () => {
      //     if (groupId) {
      //       return { display: 'none' };
      //     }
      //   },
      //   style: () => {
      //     if (groupId) {
      //       return { display: 'none' };
      //     }
      //   },
    },
    {
      dataField: 'group',
      text: 'Group',
      sort: true,
      //   hidden: groupId ? true : false,
      //   headerStyle: () => {
      //     if (groupId) {
      //       return { display: 'none' };
      //     }
      //   },
      //   style: () => {
      //     if (groupId) {
      //       return { display: 'none' };
      //     }
      //   },
    },
    {
      dataField: 'location',
      text: 'Location',
      sort: true,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
    },
    {
      dataField: 'parameter',
      text: 'Parameter',
      sort: true,
      headerStyle: { width: 100, textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'acknowledged',
      text: 'Ack',
      sort: true,
      headerStyle: { width: 60, textAlign: 'center' },
      style: { textAlign: 'center' },
      formatter: (cell) => (cell ? 'Yes' : 'No'),
      filterValue: (cell) => (cell ? 'Yes' : 'No'),
    },
    {
      dataField: 'alarmStatus',
      text: 'Alarm Status',
      sort: true,
      headerStyle: { width: '20%' },
    },
    {
      dataField: 'dumCol',
      text: 'Currently Active',
      hidden: true,
      // formatter: (cell, row) =>
      //   row.color.match(/red|cyan\/blue|yellow/g) ? 'Yes' : 'No',
      csvFormatter: (cell, row) =>
        row.color.match(/red|cyan\/blue|yellow/g) ? 'Yes' : 'No',
    },
  ];
  const defaultSorted = [
    {
      dataField: 'timeDetected',
      order: 'desc',
    },
  ];
  function rowClasses(row) {
    let className = '';
    switch (row.color.toLowerCase()) {
      case 'red':
        className = 'bg-red';
        break;
      case 'cyan/blue':
        className = 'bg-blue';
        break;
      case 'yellow':
        className = 'bg-yellow';
        break;
      default:
        break;
    }
    return className;
  }
  const actions = [
    {
      label: 'Ack alarm',
      action: () => {},
    },
    {
      label: 'Add note',
      action: () => {},
    },
    {
      label: 'Show trend chart',
      action: () => {},
    },
  ];
  function getStyles() {
    let val = parseInt(values.width);
    return {
      width: Number.isNaN(val) ? '100%' : val,
      ...getSharedDefaultStyles(),
      ...getSpacingAround(
        values.extraProperties.spacingTop,
        values.extraProperties.spacingRight,
        values.extraProperties.spacingBottom,
        values.extraProperties.spacingLeft,
      ),
    };
  }
  return (
    <>
      <div
        style={getStyles()}
        className={props.isActive === values.id ? 'selected-widget' : ''}
      >
        <div className="d-flex justify-content-between align-items-end mb-10">
          <div>
            {values.title ? <h1>{values.title}</h1> : null}
            {values.description ? (
              <span style={{ fontStyle: 'italic' }}>{values.description}</span>
            ) : null}
          </div>
          <div className="d-flex flex-1 justify-content-end align-items-end">
            <FormGroup className="mb-0 mr-5">
              <CustomInput
                type="checkbox"
                id="show-active-switch"
                label={t('Hide Inactive')}
              />
            </FormGroup>
            <ActionsDropdown options={actions} />
          </div>
        </div>
        <Datagrid
          datagridProps={{
            keyField: 'sensorId',
            data: dashboardCustomizeAlarmListData,
            columns,
            defaultSorted,
            rowClasses,
            // selectRow,
          }}
          classes="mobile-datagrid-responsive"
          showLog
          ctxMenuId="AlarmList-context"
          //   ctxMenuOptions={ctxMenuOptions}
          exportProps={{
            fileName: `AlarmList-${moment().format('MM-DD-YYYY')}.csv`,
          }}
        />
      </div>
    </>
  );
};

export default DashboardCustomWidget1;
